export function shouldShowBonusEntries(phaseNumber: number): boolean {
  return phaseNumber !== 1 && phaseNumber !== 0;
}
